/**
 * «Cuándo» sale la campaña: «Ahora» o «Programar», elegido a propósito (29/10/2026: no hay uno por defecto). La fecha y
 * hora programadas van en la hora de la zona de la campaña. Lo elegido vive en `useConfirmarCampana` (`cuando`) y se
 * muestra en «Cuándo» (`PasoCuando`, por su `elegirCuando`) y, si se llegó sin elegir (una copia llega directo), en
 * «Revisar y mandar» (`PasoConfirmar`). En una repetición, «Programar» viene con la fecha que le toca (`sugerida`).
 */
import { paisDeZona } from "../../logic/zonas";

export function ElegirCuando({ modo, onModo, local, onLocal, limites, zona, franjas, sugerida, fueraDeRango }: {
  modo: "ahora" | "programar" | null; onModo: (m: "ahora" | "programar") => void;
  /** la fecha y hora programadas, como las escribe el campo (en la zona de la campaña) */
  local: string; onLocal: (v: string) => void;
  limites: { min: string; max: string };
  zona: string;
  /** la franja en palabras («09:00 a 21:00 (lun a vie)»); "" si todavía no se sabe */
  franjas: string;
  /** una repetición: con qué fecha viene «Programar» (la que le toca), en palabras; no marca ninguno */
  sugerida?: string | null;
  /** la fecha elegida ya pasó o está a más de 30 días: por qué no sale ("" si está bien) */
  fueraDeRango?: string;
}) {
  return (
    <fieldset className="space-y-2">
      <legend className="text-sm font-semibold text-slate-800">¿Sale ahora o la programás?</legend>
      {modo === null && <p className="text-xs font-semibold text-amber-800" data-testid="falta-cuando">Elegí una de las dos: no hay una por defecto.</p>}
      <div className="flex flex-wrap items-center gap-4">
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input type="radio" name="cuando" checked={modo === "ahora"} onChange={() => onModo("ahora")} className="accent-violet-600" /> Ahora
        </label>
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input type="radio" name="cuando" checked={modo === "programar"} onChange={() => onModo("programar")} className="accent-violet-600" /> Programar
        </label>
        {modo === "programar" && (
          <>
            <input type="datetime-local" aria-label="Fecha y hora del envío" value={local} min={limites.min} max={limites.max}
              onChange={(e) => onLocal(e.target.value)}
              className="rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-500" />
            <span className="text-xs text-slate-500" data-testid="zona-del-envio">hora de {paisDeZona(zona)}</span>
          </>
        )}
      </div>
      {modo === "programar" && fueraDeRango && <p className="text-xs font-semibold text-red-700" role="alert" data-testid="cuando-fuera-de-rango">{fueraDeRango}</p>}
      {sugerida && <p className="text-xs text-slate-600" data-testid="cuando-sugerido">{sugerida}</p>}
      <p className="text-xs text-slate-500">Franja permitida: {franjas || "—"}</p>
    </fieldset>
  );
}
